module.exports = __webpack_public_path__ + "img/001.e114b0c0.png";